import React, { ChangeEvent, Component } from "react";

import { IDeviceConfigurationDocument } from "@formant/core/model/IDeviceConfigurationDocument";
import { IDeviceTeleopCustomStreamConfiguration } from "@formant/core/model/IDeviceTeleopCustomStreamConfiguration";
import { IDeviceTeleopRosStreamConfiguration } from "@formant/core/model/IDeviceTeleopRosStreamConfiguration";
import { rtcImageStreamTypes } from "@formant/core/model/rtcStreamTypes";
import { InputElement } from "@formant/ui/component/common/Field";
import { TextField } from "@formant/ui/component/common/TextField";

import { Help } from "../common/Help";
import {
    EditTeleopStreamPopup,
    IEditTeleopStreamPopupProps,
} from "./EditTeleopStreamPopup";

export interface ITeleopMouseClickConfigurationProps extends IEditTeleopStreamPopupProps {
    streamName?: string;
    document: IDeviceConfigurationDocument;
    onChange: (document: IDeviceConfigurationDocument) => void;
}

export class TeleopMouseClickConfiguration extends Component<ITeleopMouseClickConfigurationProps> {
    public render() {
        const { streamName, document, visible, onClose } = this.props;
        const stream =
            document.teleop?.rosStreams?.find(
                _ => _.topicName === streamName,
            ) ||
            document.teleop?.customStreams?.find(_ => _.name === streamName);
        const rosVideoTypes = [
            "sensor_msgs/CompressedImage",
            "sensor_msgs/Image",
            "formant/H264VideoFrame",
        ];
        const rosVideoStreamNames =
            document.teleop?.rosStreams
                ?.filter(_ => rosVideoTypes.includes(_.topicType))
                .map(_ => _.topicName) ?? [];
        const customVideoStreamNames =
            document.teleop?.customStreams
                ?.filter(_ =>
                    rtcImageStreamTypes.slice().includes(_.rtcStreamType),
                )
                .map(_ => _.name) ?? [];
        const hardwareVideoStreamNames =
            document.teleop?.hardwareStreams
                ?.filter(_ => rtcImageStreamTypes.includes(_.rtcStreamType))
                .map(_ => _.name) ?? [];
        const videoStreamNames = [
            ...rosVideoStreamNames,
            ...customVideoStreamNames,
            ...hardwareVideoStreamNames,
        ];
        return (
            <EditTeleopStreamPopup
                title={`Configuration for: ${streamName}`}
                visible={visible}
                onClose={onClose}
            >
                <p>
                    First, create a teleop image stream. Then, provide that
                    stream name here. Clicking on that image will send
                    coordinates to your designated stream. See docs for details.
                    <Help
                        text="Click for docs."
                        to="https://docs.formant.io/docs/getting-started-add-a-mouse-click-stream"
                    />
                </p>
                <TextField
                    value={stream?.mouseEventsTargetStream || ""}
                    onChange={this.onChangeAssociatedStream(stream)}
                    label="Video stream to receive clicks from"
                    placeholder="Video stream name e.g. dev.video1"
                    list={videoStreamNames}
                    autoFocus={true}
                    small={true}
                />
            </EditTeleopStreamPopup>
        );
    }

    private onChangeAssociatedStream =
        (
            stream?:
                | IDeviceTeleopRosStreamConfiguration
                | IDeviceTeleopCustomStreamConfiguration,
        ) =>
        (event: ChangeEvent<InputElement>) => {
            if (!stream) {
                return;
            }
            const { document, onChange } = this.props;
            stream.mouseEventsTargetStream = event.target.value;
            onChange({ ...document });
        };
}
